import pt from 'prop-types';
import { memo } from 'react';
import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { MatrixVector } from '../../../../components/commander-ui/Matrix';
import { RestrictionsBodyCell } from './cells';

const RestrictionsMatrixVector = memo(
    // @ts-expect-error $TSFixMeError: Property 'rowIndex' does not exist on type '{ children?: ReactNode; }'.
    ({ rowIndex, serviceId, vectorRestrictions, conditions, ...matrixVectorProps }) => (
        <MatrixVector {...matrixVectorProps}>
            {pipe(
                vectorRestrictions,
                array.mapWithIndex((columnIndex, cellRestrictions) => (
                    <RestrictionsBodyCell
                        key={`restrictions-body-cell-${rowIndex}-${columnIndex}`}
                        cellRestrictions={cellRestrictions}
                        cellConditions={conditions}
                        columnIndex={columnIndex}
                        rowIndex={rowIndex}
                        serviceId={serviceId}
                    />
                ))
            )}
        </MatrixVector>
    )
);

(RestrictionsMatrixVector as $TSFixMe).propTypes = {
    rowIndex: pt.number.isRequired,
    serviceId: pt.string.isRequired,
    vectorRestrictions: pt.arrayOf(pt.arrayOf(pt.shape({}))).isRequired,
};

export default RestrictionsMatrixVector;
